import styled, { keyframes } from 'styled-components'
import { media } from 'utils/styleUtils'
import { DARK_PAGAMO_RED, NOBEL_GRAY } from 'constants/colors'
import MissHelper from './images/Miss-helper.png'
import bubble from './images/bubble.png'

export const Container = styled.div`
  display: none;

  ${media.pad} {
    height: 165px;
    background: ${DARK_PAGAMO_RED};
    display: block;
  }
`

export const Woman = styled.div`
  position: relative;
  top: 15px;
  margin: auto;
  width: 170px;
  height: 145px;
  background: url(${MissHelper});
`

export const Bubble = styled.div`
  position: absolute;
  top: -10px;
  right: -15px;
  width: 60px;
  height: 60px;
  background: url(${bubble});
`

const pop = (opacityIn25, opacityIn50, opacityIn75) => keyframes`
  0% { opacity: 0; }
  25% { opacity: ${opacityIn25}; }
  50% { opacity: ${opacityIn50}; }
  75% { opacity: ${opacityIn75}; }
  80% { opacity: 0; }
`

export const Dot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background-color: ${NOBEL_GRAY};
  position: absolute;
  top: 22px;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  opacity: 0;

  &:nth-child(1) {
    left: 15px;
    animation-name: ${pop(1, 1, 1)};
  }
  &:nth-child(2) {
    left: 27px;
    animation-name: ${pop(0, 1, 1)};
  }
  &:nth-child(3) {
    left: 39px;
    animation-name: ${pop(0, 0, 1)};
  }
`
